import { scrollmagic } from './modules/scrollmagic';
import { globalMenu } from './modules/globalMenu';
import { slider } from './modules/slider';
import { select } from './modules/select';
import { tab } from './modules/tab';
import { anchor } from './modules/anchor';
import { countNum } from './modules/countNum';
import { hamburger } from './modules/hamburger';
import { search } from './modules/search';
import { smooth } from './modules/smooth';
import { form } from './modules/form';
import { release } from './modules/release';
import { topNews } from './modules/topNews';
import { releaseDetail } from './modules/releaseDetail';
import { koukoku } from './modules/koukoku';
import { caselist } from './modules/case';

window.addEventListener('load', () => {
  //crollに応じてアニメーションしたい時
  scrollmagic();
  
  //crollによる処理を間引きしたい時
  // scrollAction();
});

globalMenu();
slider();
koukoku();
select();
tab();
anchor();
countNum();
hamburger();
search();
smooth();
form();
release();
topNews();
releaseDetail();
caselist();